<template>
    <date-picker
            v-model="dateRange"
            type="daterange"
            :format="format"
            :picker-options="pickerOptions"
            range-separator="—"
            :editable="false"
            :clearable="false"
    />
</template>

<script>
    import Vue from 'vue'

    import {DatePicker} from 'element-ui';
    import 'element-theme-dark';

    import lang from 'element-ui/lib/locale/lang/ru-RU'
    import locale from 'element-ui/lib/locale'

    locale.use(lang);

    export default {
        props: {
            value: {
                type: Object,
                default: () => ({
                    start: undefined,
                    end: undefined
                })
            },
            dateRangeLimit: {
                type: Number,
                default: 14
            },
            format: {
                type: String,
                default: 'd MMM yyyy'
            }
        },
        data() {

            return {
                dateRange: [this.numberToDate(this.value.start), this.numberToDate(this.value.end)],
                minDateLimit: null,
                maxDateLimit: null,
                options: {
                    firstDayOfWeek: 1,
                    onPick: this.onPick
                }
            }
        },
        computed: {
            pickerOptions() {
                const minDateLimit = this.minDateLimit;
                const maxDateLimit = this.maxDateLimit;

                return Object.assign({}, this.options, {
                    disabledDate: (date) => {
                        return minDateLimit && +date < minDateLimit || maxDateLimit && +date > maxDateLimit;
                    }
                })
            },
            dateRangeLimitMillis() {
                return (this.dateRangeLimit - 1) * 24 * 60 * 60 * 1000;
            }
        },

        methods: {
            numberToDate(number) {
                if (number) {
                    const date = new Date(number);
                    date.setHours(0, 0, 0, 0);
                    return date;
                }

            },
            dateToNumber(date) {
                if (date) return date.valueOf()
            },
            onPick({maxDate, minDate}) {

                if (minDate === null && maxDate !== null) {
                    this.minDateLimit = +maxDate - this.dateRangeLimitMillis;
                    this.maxDateLimit = +maxDate + this.dateRangeLimitMillis;
                } else if (maxDate === null && minDate !== null) {
                    this.minDateLimit = +minDate - this.dateRangeLimitMillis;
                    this.maxDateLimit = +minDate + this.dateRangeLimitMillis;
                } else {
                    this.maxDateLimit = this.minDateLimit = null;
                }

            }
        },

        components: {
            DatePicker
        },

        watch: {
            dateRange(newVal) {
                this.$emit('input', {
                    start: this.dateToNumber(newVal[0]),
                    end: this.dateToNumber(newVal[1])
                });
            }
        }
    }
</script>

<style>
    .el-range-editor .el-range-input {
        line-height: 1;
        background-color: transparent;
        color: white;
    }

    .el-date-editor.el-range-editor.el-input__inner.el-date-editor--daterange{
        background-color: transparent;
        color: white;
        border-color: #409eff;
    }

    .el-date-editor .el-range__icon {
        color: white;
    }

    .el-date-editor .el-range-separator {
        color: white;
    }

    .el-date-editor .el-range__icon {
        visibility: hidden;
    }
</style>
